import { qsa, qs } from './utils.js';
import { saveAppointmentOptions, saveClientInfo, showAlert, showLoading, hideLoading } from './api.js';
import { CFG } from './config.js';
import  { validateMilitaryIdField } from './index.js';

export function bindBookButtonsValidation (container, {
    buttonSelector = '.book-now-btn',
    errorClass = 'error',
    hiddenClass = 'd-none',
    patientDropdownId = '#patient-dropdown',
    returningValue = 'return-patient',
    onSuccess = null
}) {
    const dropdowns = qsa(container, '.book__optionDropdowns .state-dropdown');
    const returnBlock = container.querySelector('.book__optionReturn');
    const returnInput = returnBlock ? returnBlock.querySelector('input') : null;

    const getLocationId = (container) => qs(container, CFG.ids.stateDd)?.dataset.id || '';
    //const getStateValue = (container) => qs(container, CFG.ids.stateDd)?.dataset.value?.toLowerCase() || '';
    const getPatientValue = (container) => qs(container, CFG.ids.patientDd)?.dataset.value?.toLowerCase() || '';
    
    console.log('Binding book buttons validation...');

    const grid = qs(container, '#appointmentContent');

    qsa(container, buttonSelector).forEach(btn => {
        // Remove old handler if exists
        if (btn._bookClickHandler) {
            btn.removeEventListener('click', btn._bookClickHandler);
        }

        // Create named handler function
        const clickHandler = (e) => {
            let hasError = false;
            console.log('book button click...');

            dropdowns.forEach(d => {
                const val = d.dataset.value || '';
                if (!val) { d.classList.add(errorClass); hasError = true; }
            });

            const patientVal = qs(container, patientDropdownId)?.dataset.value || '';
            if (patientVal === returningValue && returnBlock && returnInput && !returnBlock.classList.contains(hiddenClass)) {
                if (!returnInput.value.trim() || !returnInput.classList.contains('valid')) {
                    returnInput.classList.add(errorClass); hasError = true; 
                }
                else { returnInput.classList.remove(errorClass); }
            }

            const veteranCheck = qs(container, '#veteranCheck');
            const uploadBlock = qs(container, '.book__optionUpload');
            // const uploadList = qs(container, '#uploadList');
            // if (veteranCheck && veteranCheck.checked && uploadBlock) {
            //     const hasFile = uploadList && uploadList.querySelector('.book__uploadItem');
            //     if (!hasFile) {
            //         uploadBlock.classList.add(errorClass);
            //         hasError = true;
            //     } else {
            //         uploadBlock.classList.remove(errorClass);
            //     }
            // }

            // TODO add check for veteranCheck
            
            if (veteranCheck && veteranCheck.checked && uploadBlock) {
                let idValid = validateMilitaryIdField(container);    
                if (!idValid) {
                    hasError = true;
                } else {
                    console.log('Military ID validation passed');
                }
            }

            console.log('Validation result for book button:', hasError ? 'errors found' : 'no errors');

            if (hasError) {
                e.preventDefault();
                const firstErr = container.querySelector(`.${errorClass}`);
                firstErr?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
            
            e.preventDefault();
            
            // Collect data for AJAX request (based on old appointment.js)
                const serviceId = btn.dataset.serviceId || '';
                const servicePrice = btn.dataset.servicePrice || '';
                const serviceDuration = btn.dataset.serviceDuration || '';
                
                const locationId = getLocationId(container);
                const patientTypeVal = getPatientValue(container);
                const practitionerInput = qs(container, '[name="practitioner"]');
                const veteranCb = qs(container, '[name="veteran"]') || qs(container, '#veteran');
                const veteranIdInput = qs(container, '[name="veteran_id"]') || qs(container, '#veteran_id');
                
                const location = locationId || '';
                const patient_type = patientTypeVal || '';
                const practitioner = practitionerInput?.value || '';
                const veteran = veteranCb?.checked ? 1 : 0;
                const veteran_id = veteranIdInput?.value || '';

                // Validate veteran ID if veteran is checked
                if (veteran && !veteran_id) {
                    showAlert('Please enter your Veteran ID.');
                    veteranIdInput?.focus();
                    return;
                }

                // if we do not have <meta name="csrf_token"> in the page, the request will fail, so we simulate  loading state for local testing 
                const csrfTokenMeta = document.querySelector('meta[name="csrf_token"]');
                if (!csrfTokenMeta) {
                    console.warn('CSRF token meta tag not found. Simulating loading state for testing.');
                    showLoading(btn);
                    setTimeout(() => {
                        hideLoading(btn);
                        if (onSuccess) onSuccess({ trigger: btn });
                    }, 1000);
                    return;
                }

                // Show loading state
                showLoading(btn);

                // Send AJAX request
                saveAppointmentOptions({
                    service_id: serviceId,
                    price: servicePrice,
                    duration: serviceDuration,
                    location,
                    practitioner,
                    patient_type,
                    veteran,
                    veteran_id
                })
                .then(response => {
                    console.log('Appointment step 1 saved', response);
                    
                    // Track Added to Cart event for CustomerLabs
                    if (window.trackAddedToCart) {
                        const stateDropdown = qs(container, CFG.ids.stateDd);
                        const patientDropdown = qs(container, CFG.ids.patientDd);
                        const visiblePrice = container.querySelector('.book__prices [data-price].is-visible, .book__prices [data-price-veteran].is-visible, .book__prices [data-price-renewal].is-visible, .book__prices [data-price-transfer].is-visible');
                        
                        window.trackAddedToCart({
                            state: stateDropdown?.dataset.value || '',
                            patientType: patientTypeVal || '',
                            price: visiblePrice?.textContent?.trim() || servicePrice || '',
                            bookingDate: '', // Will be selected in next step
                            bookingTime: ''  // Will be selected in next step
                        });
                    }
                    
                    if (response.html) {
                        // Load backend response HTML
                        grid.innerHTML = response.html;
                        
                        // Dispatch event to reinitialize booking module
                        container.dispatchEvent(new CustomEvent('appointment:loaded', { bubbles: true }));
                        
                        // Call success callback
                        if (onSuccess) onSuccess({ trigger: btn });
                    } else {
                        if (onSuccess) onSuccess({ trigger: btn });
                    }
                })
                .catch(error => {
                    console.error('Save appointment options failed:', error);
                    const message = error.responseJSON?.messages?.error || error.responseText || error.statusText || 'Failed to save appointment options';
                    showAlert(message, 'error');
                    grid.innerHTML = '<div class="col"><div class="text-danger py-3">Failed to load data.</div></div>';
                })
                .finally(() => {
                    hideLoading(btn);
                });
        };

        // Store handler reference and add listener
        btn._bookClickHandler = clickHandler;
        btn.addEventListener('click', clickHandler);
    });
}

export function bindClientFormValidation (container, {
    errorClass = 'error',
    onSuccess = null
} = {}) {
    const form = qs(container, '.book__clientInformation form');
    if (!form) return;

    // Remove old handler if exists
    if (form._submitHandler) {
        form.removeEventListener('submit', form._submitHandler, true);
    }

    // Create named handler function
    const submitHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let hasError = false;

        form.querySelectorAll('input.form-control, textarea.form-control').forEach(el => {
            const name = el.getAttribute('name');
            if (name === 'note' || el.type === 'hidden') return;
            if (!el.value.trim()) {
                el.classList.add(errorClass);
                hasError = true;
            } else {
                el.classList.remove(errorClass);
            }
        });

        const reminderDd = form.querySelector('#reminder-dropdown');
        if (reminderDd) {
            const val = reminderDd.dataset.value || '';
            if (!val) {
                reminderDd.classList.add(errorClass);
                hasError = true;
            } else {
                reminderDd.classList.remove(errorClass);
            }
        }

        if (!hasError) {
            if (onSuccess) {
                // Collect form data for AJAX request
                const formData = {};
                form.querySelectorAll('input.form-control, textarea.form-control').forEach(el => {
                    const name = el.getAttribute('name');
                    if (name) {
                        formData[name] = el.value.trim();
                    }
                });

                const reminderDd = form.querySelector('#reminder-dropdown');
                if (reminderDd) {
                    formData.appointmentReminder = reminderDd.dataset.value || '';
                }

                // Show loading on submit button
                const submitBtn = qs(container, '.book__clientInformation .btn-submit');
                showLoading(submitBtn);

                // Send AJAX request to backend (based on old appointment.js)
                saveClientInfo(formData)
                    .then(response => {
                        console.log('Client info saved', response);
                        // response.price set to #total_price
                        const totalPriceEl = document.getElementById('total_price');
                        if (totalPriceEl && response.price) {
                            totalPriceEl.textContent = response.price;
                        }

                        // Populate order summary price breakdown
                        const priceBefore = document.getElementById('order-price-before');
                        if (priceBefore) priceBefore.textContent = response.price_before || response.price || '';

                        const discountRow   = document.getElementById('order-coupon-label');
                        const discountAmtEl = document.getElementById('order-discount-amount');
                        const couponCodeEl  = document.getElementById('order-coupon-code');
                        if (response.discount_amount && discountRow && discountAmtEl) {
                            discountRow.style.display    = '';
                            discountAmtEl.style.display  = '';
                            discountAmtEl.textContent    = response.discount_amount;
                            // if (couponCodeEl && response.coupon_code) {
                            //     couponCodeEl.textContent = '(' + response.coupon_code + ')';
                            // }
                        } else if (discountRow) {
                            discountRow.style.display   = 'none';
                            if (discountAmtEl) discountAmtEl.style.display = 'none';
                        }
                        
                        // Track Checkout event for CustomerLabs
                        if (window.trackCheckout) {
                            // Get booking date/time from calendar
                            const calEl = qs(container, CFG.selectors.calendar);
                            const dp = calEl?._airdp;
                            const selectedDate = dp?.selectedDates?.[0];
                            const dateStr = selectedDate ? selectedDate.toISOString().slice(0, 10) : '';
                            
                            const checkedTime = container.querySelector('.book__calendarItems input[type="radio"]:checked');
                            const timeLabel = checkedTime ? container.querySelector(`label[for="${checkedTime.id}"]`) : null;
                            const timeStr = timeLabel ? timeLabel.textContent.trim() : '';
                            
                            window.trackCheckout({
                                firstName: formData.name || '',
                                lastName: formData.last_name || '',
                                email: formData.email || '',
                                phone: formData.phone || '',
                                bookingDate: dateStr,
                                bookingTime: timeStr,
                                currency: 'USD',
                                value: parseFloat((response.price || '').toString().replace(/[^0-9.]/g, '')) || 0
                            });
                        }
                        
                        onSuccess();
                    })
                    .catch(error => {
                        console.error('Save client info failed', error);
                        const message = error.responseJSON?.messages?.error || error.responseText || 'Save failed. Please try again.';
                        showAlert(message, 'error');
                    })
                    .finally(() => {
                        hideLoading(submitBtn);
                    });
            }
        }
    };

    // Store handler reference and add listener
    form._submitHandler = submitHandler;
    form.addEventListener('submit', submitHandler, true);

    const continueBtn = qs(container, '.book__clientInformation .btn-submit');
    
    // Remove old click handler if exists
    if (continueBtn && continueBtn._clickHandler) {
        continueBtn.removeEventListener('click', continueBtn._clickHandler);
    }
    
    if (continueBtn) {
        const clickHandler = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        };
        
        continueBtn._clickHandler = clickHandler;
        continueBtn.addEventListener('click', clickHandler);
    }
}
